import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../molecules/RoundedModal'
import SydButton from '../../../commonDesign/Button'
import SydModalActions from '../../../commonDesign/SydModal/SydModalActions'

const ToggleScheduleDialog = React.forwardRef(function ToggleScheduleDialog ({ onConfirm }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false, schedule: null })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false, schedule: null })
  }, [])

  const handleConfirm = useCallback(async () => {
    try {
      setDialogState((prev) => ({ ...prev, processing: true }))
      await onConfirm(dialogState.schedule)
    } finally {
      close()
    }
  }, [dialogState.schedule, onConfirm, close])

  useImperativeHandle(ref, () => ({
    open: (schedule) => {
      setDialogState({ open: true, processing: false, schedule: structuredClone(schedule) })
    }
  }), [])

  const willEnable = dialogState.schedule && !dialogState.schedule.enabled
  const title = willEnable ? 'Enable Schedule' : 'Disable Schedule'

  return (
    <RoundedModal
      title={title}
      open={dialogState.open}
      onClose={close}
      size='medium'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <>
            <p>
              Are you sure you want to {willEnable ? 'enable' : 'disable'} schedule{' '}
              <strong>{dialogState.schedule?.name}</strong>?
            </p>
            <SydModalActions>
              <SydButton disabled={dialogState.processing} variant='ghost' size='md' onClick={close}>
                Cancel
              </SydButton>
              <SydButton
                processing={dialogState.processing}
                variant='primary'
                priority={willEnable ? undefined : 'warning'}
                size='md'
                onClick={handleConfirm}
              >
                {willEnable ? 'Enable' : 'Disable'}
              </SydButton>
            </SydModalActions>
          </>
        ) : null}
      </div>
    </RoundedModal>
  )
})

ToggleScheduleDialog.propTypes = {
  onConfirm: PropTypes.func.isRequired
}

export default ToggleScheduleDialog
